import React from 'react';

import SocialCard from "../../SocialCard";
import Section from "../../Section";

import "./Socials.css";

const cards = [
  { 
    name: "LinkedIn",
    desc: "Come see my resume and accomplishments.",
    url: "https://www.linkedin.com/in/alessandro-maclaine/",
    src: "images/linkedin.png"
  },
  {
    name: "Github",
    desc: "Come see my projects and open source libraries.",
    url: "https://github.com/ALMaclaine",
    src: "images/github.png"
  },
  {
    name: "npm",
    desc: "Come see my open source npm libraries.",
    url: "https://www.npmjs.com/~almaclaine",
    src: "images/npm.png"
  },
]

export default function Socials(props) {
  return  <Section className="portfolio-more-section">
    <a name="socials" />
    <div className="portfolio-section-title mdl-typography--display-1-color-contrast">Find Me Online</div>
    <div className="portfolio-card-container">
      {
        cards.map((e, i) => <SocialCard key={i} {...e} />)
      }
    </div>
  </Section>
}



// WEBPACK FOOTER //
// ./src/Pages/Socials/Socials.js